import React, { useEffect, useState } from "react";
import "./App.css";
import Component from "./Components/Navbar";
import HeroSection from "./Components/Hero";
import OfertaDnia from "./Components/OfferWeek";
import Aboutus from "./Components/Aboutus";
import Menu from "./Components/Menu";
import Gallery from "./Components/Gallery";
import Footer from "./Components/Footer";
import Contact from "./Components/Contact";
import SplashScreen from "./Components/Splash";

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Symulacja ładowania – splash screen wyświetlany przez 2 sekundy.
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && <SplashScreen />}
      <div className={loading ? "hidden" : "block"}>
        <Component></Component>
        <HeroSection></HeroSection>
        <Aboutus></Aboutus>
        <OfertaDnia></OfertaDnia>
        <Menu></Menu>
        <Gallery></Gallery>
        <Contact></Contact>
        <Footer></Footer>
      </div>
    </>
  );
}
